import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { money } from "../../lib/market";

export function MarketAdmin() {
  const [d, setD] = useState(null);
  const [fee, setFee] = useState("");
  const load = () => api.get("/admin/market/overview").then((r) => { setD(r.data); setFee(r.data.settings.fee_percent); });
  useEffect(() => { load(); }, []);
  const act = (p, body = {}, ok = "Saved") => api.post(p, body).then(() => { toast.success(ok); load(); }).catch((e) => toast.error(formatApiError(e)));
  async function saveFee() {
    try { await api.put("/admin/market/settings", { fee_percent: Number(fee) }); toast.success("Fee updated"); load(); } catch (e) { toast.error(formatApiError(e)); }
  }
  async function payout(o) {
    const { data } = await api.get(`/admin/market/sellers/${o.seller_id}`);
    const note = window.prompt(`Pay ${money(o.seller_net)} to ${data.user?.name} via: ${data.user?.market_payout_method || "no payout method on file"}\n\nAdd a note (e.g. Zelle ref #):`, "");
    if (note !== null) act(`/admin/market/orders/${o.order_id}/payout`, { note }, "Marked as paid out");
  }
  if (!d) return null;
  const card = "bg-white border border-[var(--line)] rounded-2xl p-5";
  return (
    <div className="space-y-8" data-testid="admin-market">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[["Active listings", d.listings_active], ["Fees earned", money(d.fees_earned)], ["Payouts owed", money(d.payouts_owed)], ["Paid orders", d.orders.length]].map(([l, v]) => <div key={l} className={card}><p className="text-2xl">{v}</p><p className="text-xs text-[var(--muted)]">{l}</p></div>)}
      </div>
      <div className={`${card} flex flex-wrap items-center gap-3`}>
        <p className="font-serif text-xl mr-auto">Marketplace fee</p>
        <input type="number" min="15" max="20" step="0.5" value={fee} onChange={(e) => setFee(e.target.value)} className="input-luxe !w-24" data-testid="admin-market-fee" /><span>%</span>
        <button onClick={saveFee} className="btn-gold !py-2" data-testid="admin-market-fee-save">Save</button>
      </div>
      <div className="space-y-2">
        <p className="font-serif text-2xl">Bridal store applications</p>
        {!d.stores.length && <p className="text-sm text-[var(--muted)]">No applications yet.</p>}
        {d.stores.map((s) => (
          <div key={s.user_id} className={`${card} flex flex-wrap items-center gap-3`} data-testid={`admin-store-${s.user_id}`}>
            <div className="mr-auto"><b>{s.store_name}</b> <span className="text-xs uppercase tracking-wider text-[var(--muted)]">· {s.status}</span><p className="text-xs text-[var(--muted)]">{[s.email, s.website, s.address, s.phone].filter(Boolean).join(" · ")}</p></div>
            {s.status !== "approved" && <button onClick={() => act(`/admin/market/stores/${s.user_id}/approve`, {}, "Store approved")} className="btn-gold !py-1.5 text-xs" data-testid={`admin-store-approve-${s.user_id}`}>Approve</button>}
            {s.status !== "rejected" && <button onClick={() => act(`/admin/market/stores/${s.user_id}/reject`, {}, "Store rejected")} className="text-xs text-red-600 underline" data-testid={`admin-store-reject-${s.user_id}`}>Reject</button>}
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <p className="font-serif text-2xl">Orders & seller payouts</p>
        {!d.orders.length && <p className="text-sm text-[var(--muted)]">No paid orders yet.</p>}
        {d.orders.map((o) => (
          <div key={o.order_id} className={`${card} flex flex-wrap items-center gap-3 text-sm`} data-testid={`admin-order-${o.order_id}`}>
            <div className="mr-auto"><b>{o.title}</b><p className="text-xs text-[var(--muted)]">{o.seller_name} → {o.buyer_email} · {new Date(o.created_at).toLocaleDateString()}{o.status === "needs_refund" && <b className="text-red-600"> · Already sold, refund buyer</b>}</p></div>
            <span>{money(o.amount)} · fee {money(o.fee)} · seller {money(o.seller_net)}</span>
            {o.payout_status === "paid" ? <span className="text-xs text-emerald-700">Paid out {o.payout_note && `(${o.payout_note})`}</span> : <button onClick={() => payout(o)} className="btn-outline-gold !py-1.5 text-xs" data-testid={`admin-order-payout-${o.order_id}`}>Mark paid out</button>}
          </div>
        ))}
      </div>
    </div>
  );
}
